// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XD7R","content":"styles_content__3lH4M"};